import { FC, useEffect, useState } from 'react';
import { useOutsideClickClose } from 'shared/lib/datepicker';
import { formatWithLocale } from 'shared/lib/datepicker/helpers/dateHelper';
import {
	MenuCalendarContext,
	SelectCalendarProviderProps,
} from 'shared/lib/selectCalendar';
import { TDay } from 'shared/types';

export const SelectCalendarProvider: FC<SelectCalendarProviderProps> = ({
	children,
	setDate,
	date,
	prohibitOpening = false,
}) => {
	const [dateString, setDateString] = useState<string>(
		formatWithLocale(new Date(), 'dd MMMM (EEE) yyyy'),
	);
	const [selectedDate, setSelectedDate] = useState<TDay>(new Date());
	const [isOpenCalendar, setOpenCalendar] = useState(false);

	const closeCalendar = () => {
		if (isOpenCalendar) {
			setOpenCalendar(false);
		}
	};

	useOutsideClickClose(closeCalendar, 'date-select-input');

	const toggleCalendarMenu = () => {
		if (prohibitOpening) {
			return;
		}

		setOpenCalendar(!isOpenCalendar);
	};

	useEffect(() => {
		if (date) {
			const day = new Date(date);
			setDateString(formatWithLocale(day, 'dd MMMM (EEE) yyyy'));
			setSelectedDate(day);
		}
	}, [date]);

	return (
		<MenuCalendarContext.Provider
			value={{
				setDateString,
				toggleCalendarMenu,
				setSelectedDate,
				isOpenCalendar,
				dateString,
				selectedDate,
				setDate,
				isDisabled: prohibitOpening,
			}}
		>
			{children}
		</MenuCalendarContext.Provider>
	);
};
